import React from 'react';
import { KFLModal, KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';

import './ModalDialog.scss';
import DialogHeader from './dialog/dialogHeader';

interface OwnProps {
  title: string;
  hideCloseBtn?: boolean;
  onClose?: () => void;
  body: any[];
  footer?: JSX.Element;
  hideFooter?: boolean;
  footerBtns?: any[];
  footerCancel?: boolean;
  footerText?: JSX.Element | string;
  classes?: any;
}

type Props = OwnProps;

const createCancelButton = (onClick: any) => (
  <KFLButton key="md-device-cancel" variant="borderless" onClick={onClick}>
    Cancel
  </KFLButton>
);

const getButtons = (
  buttons: any[],
  withCancelBtn: boolean | undefined,
  cancelFn: any
) =>
  withCancelBtn ? [createCancelButton(cancelFn), ...(buttons || [])] : buttons;

const createFooter = (
  buttons: any[],
  text: JSX.Element | string | undefined
) => (
  <div className="ModalDialogFooter">
    <div className="ModalDialogFooterText">{text}</div>
    <div className="ModalDialogButtonsArea">
      {buttons.map((bt, idx) => (
        <KFLButton key={`md-key-${idx}`} {...bt.props} />
      ))}
    </div>
  </div>
);

const ModalDialog: React.FC<Props> = (props) => {
  const footerButtons = props.footerBtns || [];
  const footer = props.hideFooter
    ? undefined
    : props.footer ||
      createFooter(
        getButtons(footerButtons, props.footerCancel, props.onClose),
        props.footerText
      );
  return (
    <KFLModal toggle={() => {}} isOpen>
      <div className={props.classes}>
        {props.children ? (
          props.children
        ) : (
          <KFLDialog
            header={
              <DialogHeader title={props.title} fnCloseDialog={props.onClose} />
            }
            sections={props.body}
            footer={footer}
          />
        )}
      </div>
    </KFLModal>
  );
};

export default ModalDialog;
